import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;
    border-radius: 0;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    background-color: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    animation: slideDown 0.2s ease-out;
    margin-top: 0;
    width: 100%;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const TextareaStyled = styled.textarea`
    width: 100%;
    min-height: 80px;
    max-height: 300px;
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray300 || '#D1D5DB'};
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    line-height: 1.5;
    resize: none;
    overflow-y: auto;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    background-color: ${(props: any) => props.theme.colors.interfacePure0};

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        box-shadow: 0 0 0 3px rgba(229, 41, 64, 0.1);
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
`;

export const ButtonStyled = styled.button<{ variant?: 'outline' | 'default' }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    transform: scale(1);

    ${props => props.variant === 'outline' ? `
        background-color: ${(props: any) => props.theme.colors.interfacePure0};
        color: ${props.theme.colors.interfaceText600 || '#374151'};
        border: 1px solid ${props.theme.colors.interfaceGray300 || '#D1D5DB'};

        &:hover:not(:disabled) {
            background-color: ${props.theme.colors.interfacePure100 || '#F2F2F2'};
            border-color: ${props.theme.colors.interfaceGray300 || '#D1D5DB'};
            transform: scale(1.02);
        }
    ` : `
        background-color: ${props.theme.colors.primaryRed400 || '#E52940'};
        color: ${(props: any) => props.theme.colors.pureWhite};

        &:hover:not(:disabled) {
            background-color: ${props.theme.colors.primaryRed500 || '#C91E32'};
            transform: scale(1.02);
        }
    `}

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:focus {
        outline: 2px solid ${props => props.variant === 'outline' ? props.theme.colors.interfaceGray400 : props.theme.colors.primaryRed400};
        outline-offset: 2px;
    }

    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 0.6;
    }

    svg {
        width: 14px;
        height: 14px;
    }
`;

